<script>
import categoryForm from "@/views/menu/category/categoryForm";
import Component, { mixins } from "vue-class-component";
import { toastService } from "@/services/toastService.js";

@Component({
  inject: {
    categoryService: "categoryService",
  },
})
export default class CategoryNew extends mixins(categoryForm) {
  formId = "new-category-form";

  get fieldColumns() {
    return 2;
  }
  get actions() {
    return [
      {
        id: "save",
        type: "submit",
        text: this.translations.labels.button_save,
        leftIcon: "mdi-content-save-outline",
        handle: this.save,
      },
    ];
  }
  async save(action, passesValidation) {
    this.errors = [];
    if (!passesValidation) {
      return;
    }
    try {
        await this.categoryService.create(this.model);
      this.$router.push("/category/list");
      toastService.success(this.translations.success.category_create);
    } catch (error) {
      this.errors = this.formatApiErrors(error);
    }
  }

  getFormTitle() {
    return this.translations.pageTitles.categories_new;
  }

  afterCreate () {
    this.model = {
      code: null,
      localizations: [],
    };
    this.isReady = true;
  }
}
</script>
